import { CzechSalaryType } from "@tymbe/legislatives/czechia/CzechSalaryType";

export const salaryTypeNameMap: Record<CzechSalaryType, string> = {
  [CzechSalaryType.DPP]: 'DPP',
  [CzechSalaryType.DPC_HPP]: 'DPČ+HPP',
}
